import React, { useState } from "react";
import axios from "axios";

function App() {
  const [text, setText] = useState("");
  const [results, setResults] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // LanguageTool API URL and configuration
    const apiUrl = "https://api.languagetool.org/v2/check";
    const data = {
      text: text,
      language: "en-US", // Change to desired language code
    };

    try {
      const response = await axios.post(apiUrl, data);
      setResults(response.data.matches || []);
    } catch (error) {
      console.error("Error with LanguageTool API:", error);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h1>LanguageTool Spell Checker</h1>
      <form onSubmit={handleSubmit}>
        <textarea
          rows="10"
          cols="50"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Enter text here..."
        />
        <br />
        <button type="submit">Check Text</button>
      </form>
      <div>
        <h2>Suggestions:</h2>
        {results.length > 0 ? (
          results.map((result, index) => (
            <div key={index}>
              <p><strong>Issue:</strong> {result.message}</p>
              <p><strong>Suggestions:</strong> {result.replacements.map(r => r.value).join(", ") || "None"}</p>
              <hr />
            </div>
          ))
        ) : (
          <p>No issues found!</p>
        )}
      </div>
    </div>
  );
}

export default App;
